document.addEventListener('DOMContentLoaded', function() {
    const productSliders = {};

    function initializeSlider(productId) {
        const track = document.querySelector(`.product-slider-track[data-product-id="${productId}"]`);
        if (!track) return;

        const images = track.querySelectorAll('img').length;
        
        productSliders[productId] = {
            currentIndex: 0,
            totalImages: images,
            track: track
        };

        updateSlider(productId);
    }

    function updateSlider(productId) {
        const slider = productSliders[productId];
        if (!slider) return;

        const translateX = -slider.currentIndex * 100;
        slider.track.style.transform = `translateX(${translateX}%)`;
    }

    // Initialize all existing sliders
    document.querySelectorAll('.product-slider-track').forEach(track => {
        const productId = track.dataset.productId;
        initializeSlider(productId);
    });

    // Use event delegation for better performance and dynamic content
    document.addEventListener('click', function(e) {
        // Handle previous button clicks
        if (e.target.closest('.product-slider-prev')) {
            e.preventDefault();
            e.stopPropagation();
            
            const btn = e.target.closest('.product-slider-prev');
            const productId = btn.dataset.productId;
            
            if (!productSliders[productId]) {
                initializeSlider(productId);
            }
            
            const slider = productSliders[productId];
            slider.currentIndex = slider.currentIndex > 0 ? slider.currentIndex - 1 : slider.totalImages - 1;
            updateSlider(productId);
        }
        
        // Handle next button clicks
        if (e.target.closest('.product-slider-next')) {
            e.preventDefault();
            e.stopPropagation();
            
            const btn = e.target.closest('.product-slider-next');
            const productId = btn.dataset.productId;
            
            if (!productSliders[productId]) {
                initializeSlider(productId);
            }
            
            const slider = productSliders[productId];
            slider.currentIndex = slider.currentIndex < slider.totalImages - 1 ? slider.currentIndex + 1 : 0;
            updateSlider(productId);
        }

        // Handle indicator clicks
        if (e.target.closest('.product-slider-indicator')) {
            e.preventDefault();
            e.stopPropagation();
            
            const indicator = e.target.closest('.product-slider-indicator');
            const productId = indicator.dataset.productId;
            const index = parseInt(indicator.dataset.index);
            
            if (!productSliders[productId]) {
                initializeSlider(productId);
            }
            
            productSliders[productId].currentIndex = index;
            updateSlider(productId);
        }
    });
});